class AddToCartController extends window.StimulusController {
  static targets = ["addToCartForm", "quantityInput"];
  static outlets = ["miniCart", "error-message", "discount-kit-volume-tiers"];
  static values = {
    successRedirectUrl: String,
  };

  get #inputValue() {
    return parseInt(this.quantityInputTarget.value);
  }

  get #canIncrement() {
    return !this.max || this.#inputValue < this.max;
  }

  get #canDecrement() {
    return this.#inputValue > this.min;
  }

  #setMinAndMaxValues() {
    if (this.hasQuantityInputTarget) {
      this.min = parseInt(this.quantityInputTarget.getAttribute("min"));
      this.max = parseInt(this.quantityInputTarget.getAttribute("max"));
      this.step = parseInt(this.quantityInputTarget.getAttribute("step"));
    }
  }

  connect() {
    this.#setMinAndMaxValues();
  }

  setDiscountKitVolumeTiersQuantity(e) {
    if (this.hasDiscountKitVolumeTiersOutlet) {
      this.discountKitVolumeTiersOutlet.setActiveTierByTierBuy(e.target.value);
    }
  }

  incrementQuantity() {
    if (this.hasQuantityInputTarget && this.#canIncrement) {
      this.quantityInputTarget.value = this.#inputValue + this.step;
    }
    this.setDiscountKitVolumeTiersQuantity({
      target: { value: this.#inputValue },
    });
  }

  decrementQuantity() {
    if (this.hasQuantityInputTarget && this.#canDecrement) {
      this.quantityInputTarget.value = this.#inputValue - this.step;
    }
    this.setDiscountKitVolumeTiersQuantity({
      target: { value: this.#inputValue },
    });
  }

  setQuantity(e) {
    if (this.hasQuantityInputTarget && this.#canIncrement) {
      this.quantityInputTarget.value = e.target.dataset.tierBuy;
    }
  }

  async add(event) {
    event.preventDefault();

    const formData = new FormData(this.addToCartFormTarget);

    try {
      const response = await fetch(this.addToCartFormTarget.action, {
        method: this.addToCartFormTarget.method,
        body: formData,
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok || response.status === 422) {
        response.json().then((data) => {
          let errorMessage = data.errors ?? data.description;
          this.errorMessageOutlet.toggleErrorMessage({
            detail: { errorMessage },
          });
        });
      } else {
        return this.miniCartOutlet.updateCart({
          event,
          detail: {
            quantity: formData.get("quantity"),
            id: formData.get("id"),
          },
        });
      }
    } catch (error) {
      console.error("Network error", error);
    }
  }
}

Stimulus.register("addToCart", AddToCartController);
